// Aggregated business status of a shared document, computed by BLA
// (docs/design/workflow-shared-documents-api.md, section 4 and shared-documents plan, section A.3).
// Which values can actually occur depends on the direction:
// - Outgoing (Workflow -> Lundify): PENDING (x/y) -> READ / APPROVED,
// - Incoming (Lundify -> Workflow): NEW -> READ,
// - NOT_SHARED: a Workflow-uploaded file that has no recipients yet (shown as "Ej delad").
// PENDING arrives as "PENDING (x/y)", so it has to be matched by prefix rather than by equality.
export const enum LundifySharedDocumentStatus {
  PENDING = 'PENDING',
  READ = 'READ',
  APPROVED = 'APPROVED',
  NEW = 'NEW',
  NOT_SHARED = 'NOT_SHARED',
}
